import { parse } from 'path';
import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getFormatedPrice } from '../../../helpers/getFormatedPrice';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Extra } from '../../Common/Extra';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  fascia: number | 'no',
  fasciaPrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (fascia, fasciaPrice, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      fascia,
      fasciaPrice,
    },
  });
};

export const Fascia = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    fascia: fasciaAddonProducts,
    custom: { fascia, measurements },
  } = state.context;

  if (isCurrentState('fascia', state) && fasciaAddonProducts.length === 0) {
    throwError(state, `window.fascia is empty`);
  }
  let variantIndex = 0;
  let fasciaVariantId = 0;
  let fasciaVariantPrice = 0;

  if (isCurrentState('fascia', state)) {
    const width = measurements.split('x')[0];
    fasciaAddonProducts[0].variants.map((variant, index) => {
      const fasciaWidth = variant.title.split('m')[0];
      if (parseInt(width, 10) < parseInt(fasciaWidth, 10) && index === 0)
        variantIndex = index;
      if (parseInt(width, 10) > parseInt(fasciaWidth, 10)) {
        return (variantIndex =
          index !== fasciaAddonProducts[0].variants.length - 1
            ? variantIndex + 1
            : index);
      }
    });

    fasciaVariantId = fasciaAddonProducts[0].variants[variantIndex].id;
    fasciaVariantPrice = fasciaAddonProducts[0].variants[variantIndex].price;
  }

  return (
    <SectionContent>
      <Heading>Fascia</Heading>
      <Selector>
        <SelectorItem
          key={fasciaVariantId}
          isSelected={fascia === fasciaVariantId}
          onClick={onClick(fasciaVariantId, fasciaVariantPrice, send)}
        >
          Fascia <Extra> + {getFormatedPrice(fasciaVariantPrice)} </Extra>
        </SelectorItem>

        <SelectorItem
          key="no"
          isSelected={fascia === 'no'}
          onClick={onClick('no', 0, send)}
        >
          No, thanks
        </SelectorItem>
      </Selector>
    </SectionContent>
  );
};
